import { useState, useEffect, memo } from "react"
import { SelectPicker, Input, DatePicker, InputGroup } from 'rsuite';
import { Row, Col } from "react-bootstrap"
import axiosService from "../../utils/axios.service";
import { format } from "date-fns"
import { Button } from 'antd';
import 'antd/dist/antd.min.css'
import { CSVDownload } from "react-csv";
import * as convert from "../constant/Convert.helper";
import Add from "./Add";
import _ from "lodash";
import async from "async"

import { status, optionsSourceFromSelect, optionsProvinceSelect } from './constant/constant'


const HeaderDataSaleOnlineV2 = ({ startDate, endDate, handleRangeDate, store, handleStore, handleSearchVoucher, sortBy, handleSortBy,
    title, type, isExport, csvData, handleExportData, header, fileName, userAdmin, onChangeKeyword, handleCreateDataSale, addLead, headerChangeStatus
    ,headerChangeHour,  headerChangeMinute, listUser, setSelectUser, handleCategory, handleSourceFrom, handleProvince, syncDataPancake, optionCategoryAll, optionProduct}) => {
    const [locations, setLocations] = useState([])
    const [locationsWidth, setLocationsWidth] = useState(window.innerWidth)
    const [createData, setCreateData] = useState(false)
    const [optionCategory, setOptionCategory] = useState([])

    const [keyword, setKeyword] = useState('')

    useEffect(async () => {
        fetchLocations()

        const { category } = await async.parallel({
            category: (cb) => {
                axiosService(`api/category?type=1&product_type=2`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
        })

        if (category.code == 200) {
            var option = []
            option.push({value: 0, label: 'All'})
            for (let item of category.data) {
                let row = {
                    value: item.id,
                    label: item.name
                }
                option.push(row)
                
            }
            setOptionCategory([...option])
        }
    }, [sortBy])

    const onChangeDate = (type,e) => {
        if (type == 0 ) {
            startDate = format(e, 'yyyy-MM-dd')
        }
        if (type == 1 ) {
            endDate = format(e, 'yyyy-MM-dd')
        }
        handleRangeDate(startDate, endDate)
       
    }

    const fetchLocations = async () => {
        if (userAdmin && [3, 4].includes(userAdmin.role)) {
            let dataStore = convert.getStoreByRole(userAdmin)
            setLocations([...dataStore])
        } else {
            const rs = await axiosService("api/stores", "GET")
            const { data } = rs
            if (data.code === 200) {
                data.data.unshift({ name_store: "Tất cả", id: 0 })
                const newLocations = data.data.map(x => {
                    return { label: x.name_store, value: x.id }
                })
                setLocations([...newLocations])
            }
        }
    }

    const onChangeKeywordHeader = _.debounce((e) => {
        if (e.length > 2 || e.length == 0) {
            setKeyword(e)
            onChangeKeyword(e)
        }
    }, 1000)

    const onChangeStore = (e) => {
        handleStore(e)
    }

    const onChangeCategory = (e) => {
        handleCategory(e)
    }
    const onChangeSourceFrom = (e) => {
        handleSourceFrom(e)
    }
    const onChangeProvince = (e) => {
        handleProvince(e ?? 0)
    }
    
    const handleExport = () => {
        handleExportData()
    }

    const showCreateLead = () => {
        setCreateData(!createData)
    }

    const onChangeStatus = (e) => {
        headerChangeStatus(e)
    }

    const onChangeHour = (e) => {
        headerChangeHour(e)
    }

    const onChangeUser = (e) => {
        setSelectUser(e)
    }

    return (
        <div className="search-report">
            <Row>
                {isExport && <CSVDownload data={csvData} headers={header} filename={fileName} target="_blank" />}
                <Col xs={type != 'locations' ? 12 : 6} md={12}>
                    {locationsWidth > 765 ?
                        <Row>
                            <Col xs={1}  className="mb-2">
                                <SelectPicker placeholder="Cơ sở" data={locations} className="w-100" defaultValue={store} onChange={onChangeStore}/>
                            </Col>
                            <Col xs={2}  className="mb-2">
                                <SelectPicker placeholder="Nhóm sản phẩm" data={optionCategory} className="w-100" defaultValue={optionCategory[0]} onChange={onChangeCategory}/>
                             </Col>
                             <Col xs={1}  className="mb-2">
                                <SelectPicker placeholder="Nguồn đặt" data={optionsSourceFromSelect} className="w-100" defaultValue={optionsSourceFromSelect[0].value} onChange={onChangeSourceFrom}/>
                             </Col>

                             <Col xs={2}  className="mb-2">
                                <SelectPicker placeholder="Tỉnh" data={optionsProvinceSelect} className="w-100" defaultValue={optionsProvinceSelect[0].value} onChange={onChangeProvince}/>
                             </Col>

                            <Col xs={1}  className="mb-2">
                                <SelectPicker data={status} className="w-100" defaultValue={status[1].value} onChange={onChangeStatus}/>
                            </Col>

                            <Col xs={1}  className="mb-2">
                                <SelectPicker placeholder="Nhân viên" data={listUser} className="w-100" defaultValue={listUser[0]} onChange={onChangeUser}/>
                            </Col>

                            <Col xs={2}  className="mb-2">
                                <Input data={keyword} placeholder="Tìm kiếm theo keyword"  onChange={onChangeKeywordHeader}/>
                            </Col>
                            <Col xs={3}  className="mb-2">
                                <InputGroup>
                                    <DatePicker defaultValue={new Date(startDate)} format="yyyy-MM-dd" block onChange={(e) => onChangeDate(0, e)} appearance="subtle" style={{ width: 230 }} />
                                    <InputGroup.Addon>to</InputGroup.Addon>
                                    <DatePicker defaultValue={new Date(endDate)} format="yyyy-MM-dd" block onChange={(e) => onChangeDate(1, e)} appearance="subtle" style={{ width: 230 }} />
                                </InputGroup>
                            </Col>

                            <Col xs={1} style={{ textAlign: "right" }}  className="mb-2">
                                <Button size="middle" type="primary"
                                    onClick={showCreateLead}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Tạo Lead
                                </Button>
                            </Col>
                            <Col xs={1} style={{ textAlign: "right" }}  className="mb-2">
                                <Button size="middle" type="primary"
                                    onClick={handleExport}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                                </Button>
                            </Col>
                            <Col xs={1} style={{ textAlign: "right" }}  className="mb-2">
                                <Button size="middle" type="primary" onClick={() => syncDataPancake()}>
                                    <i className="fa-solid fa-file-excel mr-2"></i>Cập nhật
                                </Button>
                            </Col>
                        </Row>
                    :
                        <Row>
                            <Col xs={6}  className="mb-2">
                                <SelectPicker data={locations} className="w-100" defaultValue={store} onChange={onChangeStore}/>
                            </Col>

                            <Col xs={6}  className="mb-2">
                                <SelectPicker data={status} className="w-100" defaultValue={status['All']} onChange={onChangeStatus}/>
                            </Col>

                            <Col xs={6}  className="mb-2">
                                <SelectPicker placeholder="Nhân viên" data={listUser} className="w-100" defaultValue={listUser[0]} onChange={onChangeUser}/>
                            </Col>

                            <Col xs={6}  className="mb-2">
                                <SelectPicker placeholder="Tỉnh" data={optionsProvinceSelect} className="w-100" defaultValue={optionsProvinceSelect[0].value} onChange={onChangeProvince}/>
                            </Col>

                            <Col xs={6}  className="mb-2">
                                <Input data={keyword} placeholder="Tìm kiếm theo keyword" className="w-200" onChange={onChangeKeywordHeader} />
                            </Col>
                            <Col xs={12}  className="mb-2">
                                <InputGroup>
                                    <DatePicker defaultValue={new Date(startDate)} format="yyyy-MM-dd" block onChange={(e) => onChangeDate(0, e)} appearance="subtle"  />
                                    <InputGroup.Addon>to</InputGroup.Addon>
                                    <DatePicker defaultValue={new Date(endDate)} format="yyyy-MM-dd" block onChange={(e) => onChangeDate(1, e)} appearance="subtle" />
                                </InputGroup>
                            </Col>

                            <Col xs={6} style={{ textAlign: "left" }}  className="mb-2">
                                <Button size="middle" type="primary"
                                    onClick={showCreateLead}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Tạo Lead
                                </Button>
                            </Col>
                            <Col xs={6} style={{ textAlign: "right" }}  className="mb-2">
                                <Button size="middle" type="primary"
                                    onClick={handleExport}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                                </Button>
                            </Col>
                            <Col xs={6} style={{ textAlign: "right" }}  className="mb-2">
                                <Button size="middle" type="primary"
                                    onClick={() => syncDataPancake()}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Cập nhật
                                </Button>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            {createData ?
                 <Add
                    show={createData}
                    close={showCreateLead}
                    addLead={addLead}
                    optionCategory={optionCategoryAll}
                    listUser={listUser} 
                    optionProduct={optionProduct}
                />
            : null}
        </div>
    )
}
export default memo(HeaderDataSaleOnlineV2)